import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetParamsAndResolver } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { DetailsSidebarAction } from '@cbridge-packages/details-sidebar';
import { ServerAction } from '../server.action';

type IDependencies = IClientApiDependencySegment;

export const updateServerEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetParamsAndResolver(ServerAction.update.started),
  mergeMap(({ params, resolve, reject }) => {
    const { serverId, throttlingInterval, riskReportingEnabled } = params;

    return dependencies.api.updateServer({ serverId, throttlingInterval, riskReportingEnabled }).pipe(
      mergeMap(() => {
        resolve?.();
        return [
          ServerAction.update.done({ params }),
          DetailsSidebarAction.toggleEdit(),
        ];
      }),
      catchApiError((error) => {
        const isHandled = reject?.(error.errorCode, error.description, error.params);
        return [
          ServerAction.update.failed({ params, error: null }),
          ...(isHandled ? [] : [createApiErrorNotification(error)]),
        ];
      }),
    );
  }),
);
